import { DateTime } from "luxon";
import { PromocodeService } from "../services/promocode.service";
import { AbstractControl, AsyncValidatorFn, ValidationErrors } from "@angular/forms";
import { Observable, of, map, catchError } from "rxjs";
import { Signal } from "@angular/core";
import { Event } from "./registrator";

export function normalizeDate(value: unknown): string | null {
  if (!value) return null;

  if (typeof value === 'string') {
    const dt = DateTime.fromISO(value);
    return dt.isValid ? dt.toISODate()! : '';
  }

  if (DateTime.isDateTime(value)) {
    return value.isValid ? value.toISODate()! : '';
  }

  return null;
}



export function promoCodeValidatorFactory(
  promocodeService: PromocodeService,
  // Need to pass the signal and not the value, because the value is not available at signal creation
  eventSignal: Signal<Event | null>
): AsyncValidatorFn {
  console.debug('running promoCodeValidatorFactory')
  return (control: AbstractControl): Observable<ValidationErrors | null> => {
    const code = control.value;
    if (!code) {
      return of(null);
    }
    // check if signal has been initialized
    const event: Event | null = eventSignal()
    if (event) {
      return promocodeService.getEventPromocode(event.shortName, code).pipe(
        map(promocode => {
          if (!promocode.active) {
            return { promoCodeError: 'Code is not active' }
          }
          if ((promocode.maxUses > 0) && (promocode.uses >= promocode.maxUses)) {
            if (promocode.maxUses == 1)
              return { promoCodeError: 'Code has already been used' }
            else
              return { promoCodeError: 'Max uses of the code has been reached' }
          }
          if (promocode.isExpired()) {
            return { promoCodeError: 'Code has expired' };
          }
          return null;
        }),
        catchError(err => {
          return of({ promoCodeError: err.message })
        })
      );
    }
    return of(null)
  };
}

//  promoCodeValidator(): AsyncValidatorFn {
//     return (control: AbstractControl): Observable<ValidationErrors | null> => {
//       console.log('promoCodeValidator', control)
//       const value = control.value?.trim();
//       if (!value) {
//         return of(null); // ✅ no error if empty
//       }
//       return this.promocodeService.getEventPromocode(this.event.shortName, value).pipe(
//         map(promocode => {
//           if (!promocode.active) {
//             return { promoCodeError: 'Code is not active' }
//           }
//           if ((promocode.maxUses > 0) && (promocode.uses >= promocode.maxUses)) {
//             if (promocode.maxUses == 1)
//               return { promoCodeError: 'Code has already been used' }
//             else
//               return { promoCodeError: 'Max uses of the code has been reached' }
//           }
//           if (promocode.isExpired()) {
//             return { promoCodeError: 'Code has expired' };
//           }
//           return null;
//         }),
//         catchError(err => {
//           return of({ promoCodeError: err.message })
//         })
//       );
//     };
//   }